import {
    Contact,
} from 'app/Apps/ContactManagement/Contacts/Contacts.types'
import {
    FilterType,
} from 'app/enums/common.enums'
import {
    ContactMainType,
} from 'app/enums/label.enums'
import {
    SkyDataGridColumnDefinition,
} from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid'

type ContactTable = Contact & {
    locationLocationName: string,
    locationCompanyCompanyName: string
}

const locationField: SkyDataGridColumnDefinition<ContactTable>[] = [{
    name: 'locationLocationName',
    filterField: 'locationLocationName',
    labelKey: 'LOCATION',
}]
const basicFields: SkyDataGridColumnDefinition<ContactTable>[] = [
    {
        name: 'contactName',
        filterField: 'contactName',
        filterType: FilterType.Array,
        reduced: true,
        labelKey: 'NAME_AND_SURNAME',
    },
    {
        name: 'email',
        filterField: 'email',
        filterType: FilterType.Array,
        labelKey: 'E_MAIL',
    },
    {
        name: 'phone',
        filterField: 'phone',
        filterType: FilterType.Array,
        labelKey: 'PHONE',
    },
    {
        name: 'isMainContact',
        componentName: 'ChipCheckMark',
        labelKey: 'IS_MAIN_CONTACT',
    },
    {
        name: 'countryCountryName',
        labelKey: 'BASED_IN_COUNTRY',
    },
]

const restFields: SkyDataGridColumnDefinition<ContactTable>[] = [
    {
        name: 'mainType',
        componentName: 'EnumList',
        allowedValuesEnum: ContactMainType,
        labelKey: 'TYPE',
    },
    {
        name: 'createdOn',
        labelKey: 'CREATED_ON',
    },
    {
        name: 'createdBy',
        filterField: 'createdBy',
        filterType: FilterType.Array,
        labelKey: 'CREATED_BY',
    },
]

const config = [
    ...basicFields,
    ...locationField,
    ...[{
        name: 'locationCompanyCompanyName',
        filterField: 'locationCompanyCompanyName',
        reduced: true,
        labelKey: 'COMPANY',
    }] as SkyDataGridColumnDefinition<ContactTable>[],
    ...restFields,
]

export default config
